import gql from 'graphql-tag';

export const GET_CLIENTE = gql(`
	query cliente($idLegal: String, $idioma:String) {
		cliente(idLegal: $idLegal) {
			id
            uuid
			nombre
			apellidos
			idLegal
			iban
            fechaAlta
            contactosActivos {
                email {
                    valor {
                        email 
                    }
                }
                telefono {
                    valor {
                        telefono
                    }
                }
                direccion {
                    valor {
                        tipoDireccion                       
                        direccion
                        localidad
                        provincia
                        pais
                        codigoPostal
                        
                    }
                    literalTipoVia(idioma: $idioma){
                        clave
                        valor
                    }
                    literalPais(idioma: $idioma){
                        clave
                        valor
                    }
                    literalProvincia(idioma: $idioma){
                        clave
                        valor
                    }
                }
            }
		}
	}
`);

export const ALTA_CLIENTE = gql(`
    mutation altaCliente ($altaClienteRequest: AltaClienteRequestInput) {
        altaCliente(altaClienteRequest: $altaClienteRequest) {
            id
            nombre
            apellidos
            idLegal
            iban
            fechaAlta    
        }
    }
`);

export const MODIFICA_CLIENTE = gql(`
    mutation modificarCliente ($modificarClienteRequest: ModificarClienteRequestInput) {
        modificarCliente(modificarClienteRequest: $modificarClienteRequest) {
            id
            nombre
            apellidos
            idLegal
            iban
            fechaAlta    		
        }
    }
`);

export const BORRAR_CLIENTE = gql(`
    mutation borrarCliente ($idLegal: String) {
        borrarCliente(idLegal: $idLegal) {
            id
            nombre
            apellidos
            idLegal
            iban
            fechaAlta    	
        }
    }
`);

   export const GET_LISTA_CLIENTES = gql(`
            query listaClientes($filter: [String], $sort: [String], $page: Int!, $size: Int!) {
                listaClientes(criteria: {filter: $filter, sort: $sort, page: $page, size: $size}) {
                    totalElements
                    firstElement
                    results {
                        id
                        nombre
                        apellidos
                        idLegal
                        fechaAlta                        
                    }
                }
            }
              `);
